import { Component, OnInit, ViewContainerRef, ViewChild } from '@angular/core';
import { CapacityModelService } from "./../services/CapacityModel-Service";
import { ResponseMsg } from "./../common/response-message";
import { ActivatedRoute, Router } from "@angular/router";
import { ValidateDataService } from "./../services/validate-data.service";
import { RolePayCurveMappingData } from "./../models/cm-model";
import { AuthHelper } from './../services/authHelper';
import {
  SohoModalDialogService, SohoBusyIndicatorDirective,
  SohoMessageRef, SohoNotificationService
} from "ids-enterprise-ng";
import { DatePipe } from '@angular/common';
import { UserData } from '../shared/models/user.model';

@Component({
  selector: 'app-edit-role-pay-curve-mapping',
  templateUrl: './edit-role-pay-curve-mapping.component.html',
  styleUrls: ['./edit-role-pay-curve-mapping.component.css'],
  providers: [DatePipe]
})
export class EditRolePayCurveMappingComponent implements OnInit {
  dialog!: SohoMessageRef;
  @ViewChild(SohoBusyIndicatorDirective, { static: true }) busyIndicator?: SohoBusyIndicatorDirective;

  isvalid!: boolean;
  public getTodaysDate!: Date;
  public getDate?: string;
  emailAddress!: string;
  userData = new UserData();
  message = 'Loading...';
  delay = 5;
  transparentOverlay = true;
  uniqueID: string = "0";

  public ProjectTitle = "Edit Mapping";

  constructor(
    private capacityModelService: CapacityModelService,
    private validateService: ValidateDataService,
    public model: RolePayCurveMappingData,
    private modalDialog: SohoModalDialogService,
    private router: Router,
    private route: ActivatedRoute,
    private datePipe: DatePipe,
    private authhelper: AuthHelper,
    private notificationService: SohoNotificationService
  ) { }

  ngOnInit(): void {
    Soho.Locale.set('en-US');
    this.showNotification();
    if (this.route) {
      this.route.queryParams.subscribe(params => {
        this.uniqueID = params["uniqueid"];
      });
    }
    this.userData = JSON.parse(localStorage.getItem("userprofile")!);
    if (this.userData != null && this.userData != undefined) {
      this.emailAddress = this.userData.Email;
      this.GetMappingDetails();
    }
  }
  start() {
    (this.busyIndicator as any).activated = true;
  }
  stop() {
    (this.busyIndicator as any).activated = false;
  }
  GetMappingDetails() {
    this.start();
    this.capacityModelService.GetRolePayCurveMappings().subscribe(
      mappings => {
        let match = mappings.find(m => m.uniqueid == Number(this.uniqueID));
        if (match) {
          this.model = match;
        }
        this.stop();
      },
      (error: Response) => {
        this.stop();
        this.ShowAlert("Error occurred while loading the mapping details.", ResponseMsg.ErrorMsg);
      }
    );
  }
  showNotification() {
    this.notificationService.show({
      parent: "#notification",
      message: "This page is used to edit or delete a mapping.",
      type: "info",
      linkText: "",
      link: "",
    });
    this.getTodaysDate = new Date();
    this.getDate = this.datePipe.transform(new Date(), 'MM/dd/yyyy')!;
  }
  RemoveError(id: string) {
    $("#" + id).removeMessage().removeError();
  }
  Cancel() {
    this.router.navigate(["RolePayCurveMapping"]);
  }
  ShowAlert(Message: string, Title: string, navigateBack: boolean = false) {
    const dialogRef1 = this.modalDialog
      .message("<h2>" + Message + "</h2>")
      .buttons(
        [
          {
            text: 'Ok', click: () => {
              dialogRef1.close('Ok');
              if (navigateBack) {
                this.router.navigate(["RolePayCurveMapping"]);
              }
            }, isDefault: true
          }
        ])
      .title(Title)
      .open()
      .frameHeight(1000);
  }
  ShowConfirmDelete() {
    const dialogRef1 = this.modalDialog
      .message("<h2>Are you sure you want to delete this mapping?</h2>")
      .buttons([
        {
          text: "Yes",
          click: () => {
            dialogRef1.close("Yes");
            this.DeleteMapping();
          }
        },
        {
          text: "No",
          click: () => {
            dialogRef1.close("No");
          },
          isDefault: true
        }
      ])
      .title("Confirm Delete")
      .open()
      .frameHeight(1000);
  }

  // Pay curve columns are individually optional, but a mapping is meaningless
  // unless at least one of them is filled in.
  HasAtLeastOnePayCurve(): boolean {
    let payCurves: string[] = [
      this.model.paycurve1,
      this.model.paycurve2,
      this.model.paycurve3,
      this.model.paycurve4,
      this.model.paycurve5
    ];
    return payCurves.some(payCurve => payCurve != null && payCurve.toString().trim() != "");
  }

  UpdateMapping() {
    this.model.updatedby = this.emailAddress == null ? "" : this.emailAddress;
    this.isvalid = true;
    let errorFields: string[];
    errorFields = [];
    errorFields = this.validateService.validateFormFields(this.model, ['roletype']);

    if (errorFields.length > 0) {
      for (let objField of errorFields) {
        $("#" + objField)
          .removeError()
          .addError({ message: ResponseMsg.Required, showTooltip: true });
        this.isvalid = false;
      }
    }
    if (this.isvalid && !this.HasAtLeastOnePayCurve()) {
      this.ShowAlert("At least one pay curve is required.", "Information");
      this.isvalid = false;
    }
    if (this.isvalid) {
      this.start();
      this.capacityModelService.UpdateRolePayCurveMapping(this.model).subscribe(
        response => {
          this.stop();
          this.ShowAlert("Mapping updated successfully.", ResponseMsg.Success, true);
        },
        (error: Response) => {
          this.stop();
          this.ShowAlert("Error occurred while updating the mapping.", ResponseMsg.ErrorMsg);
        }
      );
    }
  }

  DeleteMapping() {
    this.start();
    let deleteFilter = [{ uniqueid: this.model.uniqueid, userlogin: this.emailAddress == null ? "" : this.emailAddress }];
    this.capacityModelService.DeleteRolePayCurveMappings(deleteFilter).subscribe(
      response => {
        this.stop();
        this.ShowAlert("Mapping deleted successfully.", ResponseMsg.Success, true);
      },
      (error: Response) => {
        this.stop();
        this.ShowAlert("Error occurred while deleting the mapping.", ResponseMsg.ErrorMsg);
      }
    );
  }
}
